(() => {
  if (window.__menuHighlightInit__) return;
  window.__menuHighlightInit__ = true;

  const initOne = (root) => {
    const scroller = root.querySelector("[data-mh-scroller]");
    if (!scroller) return;

    const prev = root.querySelector("[data-mh-prev]");
    const next = root.querySelector("[data-mh-next]");

    const getStep = () => {
      const styles = getComputedStyle(root);
      const w = parseFloat(styles.getPropertyValue("--mh-tile-w")) || 95;
      const g = parseFloat(styles.getPropertyValue("--mh-gap")) || 20;
      return Math.max(60, w + g);
    };

    const scrollByDir = (dir) => {
      scroller.scrollBy({ left: dir * getStep(), behavior: "smooth" });
    };

    if (prev) prev.addEventListener("click", () => scrollByDir(-1), { passive: true });
    if (next) next.addEventListener("click", () => scrollByDir(1), { passive: true });

    const setVisible = (el, mode) => {
      if (!el) return;
      if (mode === "none") {
        el.style.display = "none";
        el.style.visibility = "";
      } else {
        el.style.display = "";
        el.style.visibility = mode; // "hidden" | "visible"
      }
    };

    const update = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const x = scroller.scrollLeft;

      const hasOverflow = maxScroll > 2;

      // ✅ overflow durumuna göre class toggle (CSS hizalamayı halleder)
      scroller.classList.toggle("mh-overflow", hasOverflow);

      if (!hasOverflow) {
        setVisible(prev, "none");
        setVisible(next, "none");
        return;
      }

      setVisible(prev, x <= 2 ? "hidden" : "visible");
      setVisible(next, x >= (maxScroll - 2) ? "hidden" : "visible");
    };

    scroller.addEventListener("scroll", () => requestAnimationFrame(update), { passive: true });

    if ("ResizeObserver" in window) {
      const ro = new ResizeObserver(() => update());
      ro.observe(scroller);
    } else {
      window.addEventListener("resize", update, { passive: true });
    }

    // İlk ölçüm + görseller yüklenince tekrar ölç
    update();
    setTimeout(update, 120);
    window.addEventListener("load", update, { once: true, passive: true });
  };

  const run = () => {
    document.querySelectorAll(".menu-highlight[data-mode='slider']").forEach(initOne);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
})();